import React from 'react';
import { FaDownload, FaEye, FaGraduationCap, FaCertificate, FaCalendarAlt } from 'react-icons/fa';
import Container from '../common/Container';
import useCertificates from '../../hooks/useCertificates';
import '../../styles/Certificates.css';

const Certificates = () => {
    const {
        theme,
        t,
        categories,
        certificatesRef,
        selectedCategory,
        setSelectedCategory,
        filteredCertificates,
        openPdf,
        certificatePdfs
    } = useCertificates();

    // Mapeo de íconos para usar en la selección de categoría
    const getCategoryIcon = (iconName) => {
        switch(iconName) {
            case 'certificate': return FaCertificate;
            case 'graduation-cap': return FaGraduationCap;
            case 'calendar-alt': return FaCalendarAlt;
            default: return FaCertificate;
        }
    };

    return (
        <section id="certificates" className={`certificates ${theme}`}>
            <Container>
                <div className="certificates-content">
                    <h2 className="section-title">{t.title}</h2>
                    
                    <div className="certificates-filters">
                        {categories.map(category => {
                            const Icon = getCategoryIcon(category.icon);
                            return (
                                <button
                                    key={category.id}
                                    className={`filter-button ${selectedCategory === category.id ? 'active' : ''}`}
                                    onClick={() => setSelectedCategory(category.id)}
                                >
                                    <Icon />
                                    <span>{t.categories[category.id]}</span>
                                </button>
                            );
                        })}
                    </div>

                    <div className="certificates-stats">
                        <div className="stat-item">
                            <span className="stat-number">{t.list.length}</span>
                            <span className="stat-label">{t.stats.certificates}</span>
                        </div>
                        <div className="stat-item">
                            <span className="stat-number">
                                {new Set(t.list.map(cert => cert.institution)).size}
                            </span>
                            <span className="stat-label">{t.stats.institutions}</span>
                        </div>
                    </div>
                    
                    <div className="certificates-grid" ref={certificatesRef}>
                        {filteredCertificates.map((cert, index) => (
                            <div 
                                key={index} 
                                className="certificate-card"
                                style={{ animationDelay: `${index * 0.1}s` }}
                            >
                                <div className="certificate-info">
                                    <h3 className="certificate-title">{cert.title}</h3>
                                    <div className="certificate-details">
                                        <span className="certificate-institution">
                                            <FaGraduationCap className="detail-icon" />
                                            {cert.institution}
                                        </span>
                                        <span className="certificate-date">
                                            <FaCalendarAlt className="detail-icon" />
                                            {cert.date}
                                        </span>
                                    </div>
                                    <div className="certificate-badges">
                                        {cert.badges.map((badge, i) => (
                                            <span key={i} className="badge">
                                                {badge}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                                
                                <div className="certificate-actions">
                                    <button 
                                        className="certificate-button view"
                                        onClick={() => openPdf(cert.title)}
                                    >
                                        <FaEye /> {t.actions.view}
                                    </button>
                                    <a 
                                        href={certificatePdfs[cert.title]} 
                                        download
                                        className="certificate-button download"
                                    >
                                        <FaDownload /> {t.actions.download}
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default Certificates;